module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Bowlers: By Economy")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 most economical bowlers across all seasons\n      of IPL.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Economy = Total Runs Conceded / Total Overs Bowled.\n    ")]), _vm._v(" "), _c('small', [_vm._v("** Only bowlers that have bowled 300+ overs are included.")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Lasith Malinga of Mumbai Indians is the most economical bowler across\n        all seasons on IPL with an economy of 6.349.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Ravichandran Ashwin comes second with a small margin at 6.359.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-396b1810"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/BowlerEconomy.vue
// module id = 398
// module chunks = 1